<div class="child-grid-header ap-green-background">Customer Connections: (Demand)</div>

<dx-data-grid id="CustomerConnectionGrid" [dataSource]="customerConnectionDataSource" [showBorders]="true"
    [columnAutoWidth]="true" (onToolbarPreparing)="onCustomerGridToolbarPreparing($event)"
    (onRowInserted)="addCustomerConnection($event)" (onRowUpdated)="updateCustomerConnection($event)"
    (onRowRemoved)="deleteCustomerConnection($event)" [allowColumnResizing]="true" [showRowLines]="true"
    [showColumnLines]="true" [showBorders]="true">
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-editing mode="popup" [useIcons]="true" [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true">
        <dxo-popup title="{{pipelineCode}} ({{materialName}})" [showTitle]="true" [toolbarItems]="[  
            {  
            widget: 'dxButton',  
            location: 'after',  
            options: {  
              text: 'Save',  
              icon: '',
              stylingMode:'contained',
              type:'success'
            },  
            toolbar: 'bottom',  
            onClick: onSaveClick  
        },{  
            widget: 'dxButton',  
            location: 'after',  
            options: {  
              text: 'Cancel',  
              icon: '' ,
              type:'danger'   
            },  
            toolbar: 'bottom',  
            onClick: onCancelClick  
        }]">
        </dxo-popup>
    </dxo-editing>
    <dxi-column type="buttons" [width]="120">
        <dxi-button stylingMode="outlined" [onClick]="editCustomerSite" type="default" text="Edit Site">
        </dxi-button>
        <dxi-button name="edit"></dxi-button>
        <dxi-button name="delete"></dxi-button>
    </dxi-column>
    <dxi-column dataField="customerSiteId" caption="Customer Site" [width]="250">
        <dxi-validation-rule type="required"></dxi-validation-rule>
        <dxo-lookup [dataSource]="sites" displayExpr="siteName" valueExpr="siteId">
        </dxo-lookup>
    </dxi-column>
    <dxi-column dataField="quantity"></dxi-column>
    <dxi-column dataField="uom" [setCellValue]="setUOMValue" caption="UOM" [width]="250">
        <dxo-lookup [dataSource]="uoms" displayExpr="fromUOM" valueExpr="fromUOM">
        </dxo-lookup>
    </dxi-column>
    <dxi-column dataField="connectionNotes" [visible]="true" editCellTemplate="editTextTemplate"></dxi-column>
    <div *dxTemplate="let cellInfo of 'editTextTemplate'">
        <dx-text-area [height]="90" (onValueChanged)="cellInfo.setValue($event.value)" [value]="cellInfo.value">
        </dx-text-area>

    </div>
</dx-data-grid>